import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExcelFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={32}
    height={32}
    fill='none'
    {...props}
  >
    <rect width={32} height={32} fill='url(#excelFile_svg__a)' rx={6} />
    <defs>
      <pattern id='excelFile_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#excelFile_svg__b' transform='matrix(.00156 0 0 .00156 0 .034)' />
      </pattern>
      <image
        xlinkHref='/images/icons/excel-file-74e63562.webp'
        id='excelFile_svg__b'
        width={640}
        height={596}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgExcelFile;
